import PropTypes from 'prop-types';
import styled from 'styled-components';
import Container from '../../components/styled/Container';

const Wrapper = styled.div``;

const Header = styled.div`
  width: 100%;
  position: fixed;
  top: 76px;
  padding: 20px 0;
  background-color: #ffffff;
  border-bottom: 1px solid #7b71f6;
  z-index: 1;
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.div`
  color: #3c3881;
  font-size: 28px;
  font-weight: 600;
`;

const Actions = styled.div``;

// Nav header + Layout header + padding (20px)
const Content = styled.main`
  padding: 174px 0 20px 0;
`;

const Layout = ({ title, actions, children }) => {
  return (
    <Wrapper>
      <Header>
        <Container>
          <HeaderWrapper>
            <Title>{title}</Title>
            {actions ? <Actions>{actions}</Actions> : null}
          </HeaderWrapper>
        </Container>
      </Header>

      <Container>
        <Content>{children}</Content>
      </Container>
    </Wrapper>
  );
};

Layout.propTypes = {
  title: PropTypes.string.isRequired,
  actions: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default Layout;
